module.exports = __webpack_public_path__ + "img/hgro2.5ae603a7.jpg";